exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_wks-ext.js
// module id = 26
// module chunks = 0 1